// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".stone-rebrand-logo__svg[data-v-07d7c9a1]{display:block;height:32px;width:auto}", ""]);
// Exports
module.exports = exports;
